import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Container } from 'reactstrap'
import Components from '../components'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

const HOME_NAME = 'VPPGamingNetwork'
const SUB_NAME = 'Auth'

@inject('Auth')
@observer
export class AuthNavigator extends React.Component {
  componentWillMount() {
    document.title = `${SUB_NAME} - ${HOME_NAME}`
  }

  render() {
    if (this.props.Auth.token.accessToken) {
      return <Redirect to={`/dashboard`} />
    }

    return (
      <Container fluid>
        <Components.partials.Header />
        <Switch>
          <Route exact path={'/auth/login'} component={Components.Login} />
          <Route exact path={'/auth/signup'} component={Components.Register} />
          <Route exact path={'/auth/remind'} component={Components.Remind} />
        </Switch>
        <Components.partials.Footer />
      </Container>
    )
  }
}

export default AuthNavigator



// WEBPACK FOOTER //
// ./src/navigators/Auth.js